import { AllocationName } from 'api';
import { getObjectValue } from 'utilities';
import { InitialAllocationStatus } from './getInitialAllocationStatus.types';

const getInitialAllocationStatus = (
  allocationVersion: AllocationName | InitialAllocationStatus | null
): InitialAllocationStatus => {
  const { is_final: isFinal = false, is_published: isPublished = false } = getObjectValue(allocationVersion);

  return { is_final: isFinal, is_published: isPublished };
};

export default getInitialAllocationStatus;
